import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";
import { wordTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.word";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * Maps each word to the graphemes it contains. One row per (word, grapheme).
 *
 * Lets the dictionary lookup find every word containing a grapheme via an
 * indexed equality on `grapheme_id`, instead of a `LIKE '%glyph%'` substring
 * match that forces a full table scan of `word`.
 */
export const wordGraphemeTable = staticTable(
  "word_grapheme",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),
    wordId: integer("word_id")
      .notNull()
      .references(() => wordTable.id),
  },
  (table) => [
    index("word_grapheme_grapheme_id_idx").on(table.graphemeId),
    index("word_grapheme_word_id_idx").on(table.wordId),
  ],
);

export type WordGrapheme = typeof wordGraphemeTable.$inferSelect;
